
define("rv!templates/hotelimagesList",[],function(){return { v:3,
  t:[ { t:4,
      f:[ { t:7,
          e:"div",
          a:{ "class":"alert alert-error" },
          f:[ { t:2,
              r:"error" } ] } ],
      n:50,
      x:{ r:[ "error" ],
        s:"_0!=null" } },
    "YAR: ",
    { t:2,
      r:"showingSmallImages" },
    " ",
    { t:7,
      e:"div",
      a:{ "class":"right" },
      f:[ { t:7,
          e:"strong",
          f:[ "Total: ",
            { t:2,
              r:"Data.HotelImages.length" },
            " Showing: ",
            { t:2,
              x:{ r:[ "getShowingCount",
                  "Data.HotelImages" ],
                s:"_0(_1)" } } ] } ] },
    " ",
    { t:7,
      e:"br",
      a:{ "class":"clear" } },
    " ",
    { t:7,
      e:"ul",
      a:{ id:"sortable" },
      f:[ { t:4,
          f:[ { t:7,
              e:"li",
              a:{ "class":[ "well ",
                  { t:4,
                    f:[ "searchImage" ],
                    n:50,
                    x:{ r:[ "Rank" ],
                      s:"_0===0" } },
                  { t:4,
                    n:51,
                    f:[ { t:4,
                        n:50,
                        x:{ r:[ "Show" ],
                          s:"_0" },
                        f:[ "slideImage" ] },
                      { t:4,
                        n:50,
                        x:{ r:[ "Show" ],
                          s:"!(_0)" },
                        f:[ "nonSlideImage" ] } ],
                    x:{ r:[ "Rank" ],
                      s:"_0===0" } } ],
                id:[ { t:2,
                    r:"Id" } ] },
              f:[ { t:7,
                  e:"div",
                  a:{ "class":"imageForm" },
                  f:[ { t:7,
                      e:"a",
                      a:{ href:[ { t:2,
                            r:"hotelImagesUrlStart" },
                          { t:2,
                            r:"Id" },
                          ".jpg" ],
                        title:"View fullsize image saved on our side, if any, new tab. If this image is marked as 'show' and everything is saved, this would be the image shown on the slideshow.",
                        target:"_blank" },
                      f:[ { t:4,
                          f:[ { t:7,
                              e:"img",
                              a:{ src:"https://adestinn2blob.blob.core.windows.net/images/placeholder.gif",
                                "class":"smallImage",
                                "data-original":[ "/api/hotels/previewcrop/?width=60&height=60&photoUrl=",
                                  { t:2,
                                    x:{ r:[ "Url" ],
                                      s:"encodeURIComponent(_0)" } } ],
                                alt:"",
                                style:"display: inline;" } } ],
                          n:50,
                          r:"showingSmallImages" },
                        { t:4,
                          n:51,
                          f:[ { t:7,
                              e:"img",
                              a:{ src:"https://adestinn2blob.blob.core.windows.net/images/placeholder.gif",
                                "class":"bigImage",
                                "data-original":[ { t:4,
                                    f:[ "/api/hotels/previewcrop/?width=300&height=202&photoUrl=",
                                      { t:2,
                                        x:{ r:[ "Url" ],
                                          s:"encodeURIComponent(_0)" } } ],
                                    n:50,
                                    x:{ r:[ "Rank" ],
                                      s:"_0===0" } },
                                  { t:4,
                                    n:51,
                                    f:[ { t:2,
                                        r:"Url" } ],
                                    x:{ r:[ "Rank" ],
                                      s:"_0===0" } } ],
                                alt:"",
                                style:"display: inline;" } } ],
                          r:"showingSmallImages" } ] },
                    " ",
                    { t:7,
                      e:"strong",
                      f:[ { t:2,
                          r:"Rank" },
                        ")" ] },
                    " ",
                    { t:7,
                      e:"input",
                      a:{ type:"text",
                        placeholder:"Caption",
                        value:[ { t:2,
                            r:"Caption" } ],
                        "class":"captionBox" } },
                    " ",
                    { t:4,
                      f:[ { t:7,
                          e:"label",
                          a:{ "for":[ "show_",
                              { t:2,
                                r:"Id" } ],
                            title:"Show on the slide show on hotel details" },
                          f:[ "Show" ] },
                        " ",
                        { t:7,
                          e:"input",
                          a:{ id:[ "show_",
                              { t:2,
                                r:"Id" } ],
                            type:"checkbox",
                            checked:[ { t:2,
                                r:"Show" } ] } } ],
                      n:50,
                      x:{ r:[ "Rank" ],
                        s:"_0!==0" } },
                    " (",
                    { t:2,
                      r:"Width" },
                    "x",
                    { t:2,
                      r:"Height" },
                    ") ",
                    { t:4,
                      f:[ "Note the 300x202 preview image displayed" ],
                      n:50,
                      x:{ r:[ "Rank" ],
                        s:"_0===0" } },
                    " " ] },
                " ",
                { t:7,
                  e:"div",
                  a:{ "class":"right" },
                  f:[ { t:4,
                      f:[ { t:7,
                          e:"div",
                          a:{ "class":"right" },
                          f:[ { t:4,
                              f:[ { t:7,
                                  e:"a",
                                  a:{ href:"#",
                                    title:"move up",
                                    "class":"icon-arrow-up" },
                                  v:{ click:"moveUp" } } ],
                              n:50,
                              x:{ r:[ "Rank" ],
                                s:"_0!==0" } },
                            " ",
                            { t:7,
                              e:"br" },
                            { t:7,
                              e:"br" },
                            " ",
                            { t:4,
                              f:[ { t:7,
                                  e:"a",
                                  a:{ href:"#",
                                    title:"move down",
                                    "class":"icon-arrow-down" },
                                  v:{ click:"moveDown" } } ],
                              n:50,
                              x:{ r:[ "Rank",
                                  "Data.HotelImages.length" ],
                                s:"_0!==_1-1" } } ] } ],
                      n:50,
                      x:{ r:[ "Rank" ],
                        s:"_0!=null" } },
                    " ",
                    { t:7,
                      e:"div",
                      a:{ "class":"right" },
                      f:[ { t:4,
                          f:[ { t:7,
                              e:"a",
                              v:{ click:"moveToTop" },
                              a:{ href:"#" },
                              f:[ "Move To Top" ] } ],
                          n:50,
                          x:{ r:[ "Rank" ],
                            s:"_0!==0" } },
                        " ",
                        { t:7,
                          e:"br" },
                        " ",
                        { t:7,
                          e:"span",
                          a:{ "class":"sideNote" },
                          f:[ { t:2,
                              r:"CreateDate" } ] },
                        " ",
                        { t:7,
                          e:"br" },
                        " ",
                        { t:7,
                          e:"a",
                          a:{ href:"#",
                            "class":"icon-remove",
                            title:"Delete this image! GROSS!" },
                          v:{ click:"deleteImage" } } ] } ] },
                " ",
                { t:7,
                  e:"br",
                  a:{ "class":"clear" } } ] } ],
          n:52,
          r:"Data.HotelImages" } ] } ] };});
